"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactsTab = void 0;
const button_1 = require("client/components/material/button");
const store_1 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_contacts_1 = require("../../components/edit-contacts");
const store_2 = require("../../store");
require("./contacts.less");
let ContactsTab = class ContactsTab extends react_1.Component {
    render() {
        const siteId = Number(this.props.params[0]);
        const rowId = Number(this.props.params[1]);
        return (React.createElement("div", { className: "providers__form" },
            store_1.usersStore.permissions.CreateProvider && (React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-provider-btn", to: `/pharmacies/${siteId}/contacts/0` },
                React.createElement(Add_1.default, null))),
            React.createElement(edit_contacts_1.EditContacts, { error: store_2.sitesDetailStore.editProviders.error, loading: store_2.sitesDetailStore.editProviders.loading, site: siteId ? siteId : null, rowId: !isNaN(rowId) ? rowId : null, onSave: e => console.log(e) })));
    }
};
ContactsTab = __decorate([
    mobx_react_1.observer
], ContactsTab);
exports.ContactsTab = ContactsTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/contacts/contacts.tsx
// module id = 4010
// module chunks = 0